<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="2"
        md="3"
      >
        <statistic-card-with-area-chart
          v-if="membersGained"
          icon="UsersIcon"
          :statistic="kFormatter(membersGained.count)"
          :statistic-title="$t('Members')"
          :chart-data="membersGained.series"
        />
      </b-col>
      <b-col
        xl="2"
        md="3"
      >
        <statistic-card-with-area-chart
          v-if="workingGroups"
          icon="CodesandboxIcon"
          color="warning"
          :statistic="kFormatter(workingGroups.count)"
          :statistic-title="$t('Working Groups')"
          :chart-data="workingGroups.series"
        />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <ecommerce-statistics :data="eventStatistics" />
      </b-col>
    </b-row>
    <div
      v-if="featuredCongresses.length > 0"
      class="mt-4 mb-2"
    >
      <h1 class="text-center mt-3 pb-2">
        {{ $t('Featured Congresses') }}
      </h1>
      <b-row>
        <b-col
          v-for="congress in featuredCongresses"
          :key="congress.id"
          cols="12"
          md="6"
          lg="3"
          class="d-flex"
        >
          <b-card
            :title="congress.title"
            :img-src="congress.bgBanner || congress.logo"
            :img-alt="congress.title"
          >
            <b-card-text class="flex-grow-1">
              {{ congress.shortDescription }}
            </b-card-text>
            <div class="mt-2 d-flex justify-content-between align-items-center">
              <b-button
                v-if="!congress.websiteId"
                variant="primary"
                :to="{ name: 'congress-view', params: { id: congress.id } }"
                class="mt-2 align-self-start"
              >
                {{ $t('Read More') }}
              </b-button>
              <b-dropdown
                v-else
                :text="$t('Read More')"
                variant="primary"
                class="align-self-start"
                split
                right
                @click="$router.push({ name: 'congress-view', params: { id: congress.id } })"
              >
                <b-dropdown-item :to="{ name: 'congress-participation', params: { id: congress.id } }">
                  {{ $t('My Participation') }}
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item
                  :href="`https://www.hcs.gr/scientific-programme/${congress.websiteId}`"
                  target="_blank"
                >
                  {{ $t('Sessions') }}
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item
                  v-if="isBeforeNow(congress.startDate)"
                  :href="`https://www.hcs.gr/web-tv-videos/${congress.websiteId}`"
                  target="_blank"
                >
                  {{ $t('Videos') }}
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item
                  v-if="congress.adaudienceId && !!congress.submissionDeadline && isAfterNow(congress.submissionDeadline)"
                  :href="`https://www.adaudience.gr/submit-abstract/58?author_mail=${userData.email}`"
                  target="_blank"
                >
                  {{ $t('Submit Abstract') }}
                </b-dropdown-item>
              </b-dropdown>
              <calendar-btn
                :congress="congress"
                size="1"
                hide-label
                class="align-self-start"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import axios from '@/libs/axios'
import { BRow, BCol } from 'bootstrap-vue'
import { getUserRights } from '@/auth/utils'
import { kFormatter } from '@core/utils/filter'
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import CalendarBtn from '@/components/CalendarBtn.vue'

export default {
  components: {
    BRow,
    BCol,
    StatisticCardWithAreaChart,
    EcommerceStatistics,
    CalendarBtn
  },
  data() {
    return {
      data: {},
      featuredCongresses: [],
      membersGained: {
        series: [
          {
            name: this.$t('Members'),
            data: [28, 40, 36, 52, 38, 60, 55],
          },
        ],
        count: 3900,
      },
      workingGroups: {
        series: [
          {
            name: this.$t('Working Groups'),
            data: [10, 15, 8, 15, 7, 12, 8],
          },
        ],
        count: 0,
      },
      eventStatistics: [],
    }
  },
  computed: {
    userData() {
      return this.$store.getters['app-common/userData']
    },
  },
  mounted() {
    if (getUserRights().includes('Congress_Management_Congress_View')) {
      this.$store.dispatch('app-common/fetchDetailedCongresses', { featured: true }).then(response => {
        this.featuredCongresses = response.data.content
      })
    }
  },
  created() {
    this.updateEventStats()
    this.updateWorkingGroupStats()
  },
  methods: {
    async updateEventStats() {
      const response = await axios.get('statistics/events')
      this.eventStatistics = this.createEventStatsObj(response.data)
    },
    async updateWorkingGroupStats() {
      const response = await axios.get('statistics/working-groups')
      this.workingGroups.count = response.data.count
    },
    createEventStatsObj(item) {
      return [
        {
          icon: 'GlobeIcon',
          color: 'light-primary',
          title: item.panhellenic,
          subtitle: this.$t('Panhellenic'),
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'CodesandboxIcon',
          color: 'light-info',
          title: item.wgseminars,
          subtitle: this.$t('WG seminars'),
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'CalendarIcon',
          color: 'light-danger',
          title: item.peripheral,
          subtitle: this.$t('Peripheral'),
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'CastIcon',
          color: 'light-success',
          title: item.webinars,
          subtitle: this.$t('Webinars'),
          customClass: '',
        },
      ]
    },
    kFormatter,
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
